const TheContainer = () => import("@/containers/TheContainer.vue")
const AdminPayoutList = () => import('./AdminPayoutList.vue')
const AdminPayoutDetail = () => import('./AdminPayoutDetail.vue')

export default [
  // Admin scope - all payouts
  {
    path: '/admin/payouts',
    component: TheContainer,
    meta: {perms: ['admin.payouts.list']},
    redirect: {name: 'adminPayoutList'},
    children: [
      {
        path: '',
        name: 'adminPayoutList',
        component: AdminPayoutList,
        meta: {label: 'Admin Payouts'}
      },
      {
        path: ':id',
        name: 'adminPayoutDetail',
        component: AdminPayoutDetail,
        meta: {label: 'Payout Detail'}
      }
    ]
  },
  // Contract Manager scope - filtered payouts
  {
    path: '/contract-manager/:contractManagerId/payouts',
    component: TheContainer,
    meta: {perms: ['admin.payouts.list']},
    children: [
      {
        path: '',
        name: 'contractManager.payouts',
        component: AdminPayoutList,
        meta: {label: 'Contract Manager Payouts'}
      },
      {
        path: ':id',
        name: 'contractManager.payoutDetail',
        component: AdminPayoutDetail,
        meta: {label: 'Payout Detail'}
      }
    ]
  }
]